export default "__VITE_ASSET__BALHCqaK__"